import {type FC} from 'react';

import {NewBadgePopupTemplate} from '@/views/Loyalty/PopupTemplates';

interface INewBadgeTemplateProps {
    loyaltyInfo?: {
        journeyId: string;
    };
    subTitle: string;
}

export const NewBadgeTemplate: FC<INewBadgeTemplateProps> = ({loyaltyInfo, subTitle}) => {
    return (
        <div className='relative mb-6 bg-primary-dark px-4 py-6 ml:p-0'>
            <h2 className='mb-4 mt-8 text-20 font-bold text-primary-dark-30 ml:absolute ml:my-4 ml:mb-0 ml:mt-0'>
                {subTitle}
            </h2>
            <NewBadgePopupTemplate isChipVisible headerClassName='justify-end' journeyId={loyaltyInfo?.journeyId} />
        </div>
    );
};
